<template>
    <v-container fluid>
      <material-card
        icon="mdi-clipboard-text"
        inline
        title="Create Student Classwork"
      >
        <v-card-actions>
          <router-link :to="{ name: 'viewClassWork' }">
            <v-btn
              v-if="$vuetify.breakpoint.smAndUp"
              elevation="1"
              absolute
              top
              right
            >
              <v-icon left>mdi-arrow-left</v-icon>back
            </v-btn>
            <v-btn
              v-else
              fixed
              right
              fab
              small
              color="grey lighten-2"
              elevation="1"
              class="mr-n2 mt-10"
              style="opacity: 0.6"
            >
              <v-icon>mdi-arrow-left</v-icon></v-btn
            >
          </router-link>
        </v-card-actions>
        <v-card flat class="px-2">
          <form @submit.prevent="save">
            <v-row>
              <v-col cols="12" md="6" lg="4">
                <label class="font-weight-medium body-2"
                  >Select Academic Year <span class="error--text">*</span></label
                >
                <v-autocomplete
                  class="my-0 py-1"
                  placeholder="--Select--"
                  v-model="academicYearID"
                  required
                  :items="academicYears"
                  key="id"
                  item-value="id"
                  item-text="academicYear"
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="font-weight-medium body-2"
                  >Select franchisee <span class="error--text">*</span></label
                >
                <div class="control select is-fullwidth">
                  <multiselect
                    class="overflowmultiselect2"
                    label="companyName"
                    track-by="companyName"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="false"
                    :multiple="true"
                    :options="franchiseeArr"
                    v-model="franchiseeID"
                  >
                  </multiselect>
                </div>
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="font-weight-medium body-2"
                  >Date <span class="error--text">*</span></label
                >
                <custom-date-picker
                  :minToDate="minDate"
                  :maxToDate="maxDate"
                  v-model="date"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium"
                  >Class-Section <span class="error--text">*</span>
                </label>
                <multiselect
                  class="overflowmultiselect2"
                  label="value"
                  track-by="id"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  :preselect-first="false"
                  :multiple="true"
                  :options="classSectionArray"
                  v-model="classSectionID"
                >
                </multiselect>
              </v-col>
              <v-col cols="12" md="6">
                <label class="body-2 font-weight-medium"
                  >Title <span class="error--text">*</span>
                </label>
                <v-text-field
                  label="Classwork Title"
                  v-model="classWorkTitle"
                  outlined
                  dense
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="8">
                <label class="font-weight-medium body-2"> Class Work </label>
                <quill-editor
                  v-model="classwork"
                  theme="snow"
                  ref="myQuillEditor"
                >
                </quill-editor>
              </v-col>

              <v-col cols="12" md="6" lg="4">
                <label class="body-2 font-weight-medium">
                  Select Class Work File
                </label>

                <b-field class="file is-primary">
                  <b-upload
                    @input="onclassFilechange()"
                    v-model="classworkfile"
                    multiple
                    class="file-label"
                  >
                    <span class="file-cta">
                      <b-icon class="file-icon" icon="upload"></b-icon>
                      <span class="file-label">Click to upload</span>
                    </span>
                  </b-upload>
                </b-field>
                <div class="pink--text body-2">
                  [ Allowed files: .gif, .png, .jpg, .jpeg, .xlsx, .xls, .csv,
                  .doc, .pdf, .txt, .docx, .pptx, .pptm, .ppt, .xps, .potx,.potm,
                  .pot, thmx, .ppsx, .pps, .ppam, .ppa, .mp3, .wma, .aac, .wav,
                  .flac, .mp4, .avi, .m4p, .m4v, .wmv, .mov, .webm, .mpg, .mp2,
                  .mpeg, .mpe, .mpv, .ogg, .flv, .mkv ]
                </div>

                <div v-if="classworkfile.length > 0">
                  <v-chip
                    v-for="(file, i) in classworkfile"
                    :key="i"
                    color="primary"
                    label
                    outlined
                    class="ma-2"
                    close
                    @click:close="deleteclassworkfile(i)"
                  >
                    {{ file.name }}
                  </v-chip>
                </div>
              </v-col>
              <v-col cols="12">
                <v-card-actions class="d-flex justify-end">
                  <v-btn
                    :disabled="hasClicked"
                    bottom
                    right
                    elevation="1"
                    color="primary"
                    type="submit"
                  >
                    <v-icon left> mdi-content-save </v-icon>
                    Save
                  </v-btn>
                </v-card-actions>
              </v-col>
            </v-row>
          </form>
        </v-card>
      </material-card>
      <loading-icon :value="isLoading" />
    </v-container>
  </template>
<script>
import constants from '@/utils/constants'
import MaterialCard from '@/components/template/MaterialCard'
import CustomDatePicker from '../../template/CustomDatePicker.vue'
import Utils from '@/utils'
import _ from 'lodash'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'createStudentSubjectDiary',
  components: {
    Multiselect,
    MaterialCard,
    CustomDatePicker,
    quillEditor
  },
  data () {
    return {
      total: 0,
      date: moment().format('YYYY-MM-DD'),
      classworkfile: [],
      discriptionfile: [],
      franchiseeID: '',
      franchiseeArr: [],
      academicYearID: '',
      classwork: '',
      isLoading: false,
      type: '',
      academicYears: [],
      selectedClassID: '',
      selectedSectionID: '',
      classID: '',
      title: '',
      classWiseSections: [],
      minDate: moment().format('YYYY-MM-DD'),
      maxDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      classes: [],
      sections: [],
      tempArray: [],
      hasClicked: false,
      loader: true,
      isWrite: false,
      classSectionArray: [],
      classSectionID: '',
      allowedFiles: [
        'gif',
        'png',
        'jpg',
        'jpeg',
        'xlsx',
        'xls',
        'csv',
        'doc',
        'pdf',
        'txt',
        'docx',
        'pptx',
        'pptm',
        'ppt',
        'xps',
        'potx',
        'potm',
        'pot',
        'thmx',
        'ppsx',
        'pps',
        'ppam',
        'ppa',
        'mp3',
        'wma',
        'aac',
        'wav',
        'flac',
        'mp4',
        'avi',
        'm4p',
        'm4v',
        'wmv',
        'mov',
        'webm',
        'mpg',
        'mp2',
        'mpeg',
        'mpe',
        'mpv',
        'ogg',
        'flv',
        'mkv'
      ],
      classWorkTitle: ''
    }
  },

  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    await this.getFranchiseeList()
    await this.getYear()
  },
  beforeRouteLeave (to, from, next) {
    next()
  },
  beforeMount () {
    window.addEventListener('beforeunload', this.preventNav)
  },
  beforeDestroy () {
    window.removeEventListener('beforeunload', this.preventNav)
  },
  watch: {
    franchiseeID: async function () {
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassList()
      }
    },
    academicYearID: async function () {
      if (this.academicYearID && this.franchiseeID) {
        await this.getClassList()
      }
    },
    selectedClassID () {
      this.selectedSectionID = ''
    }
  },
  methods: {
    preventNav (event) {
      if (!this.hasDataChanged()) return
      event.preventDefault()
      event.returnValue = ''
    },
    hasDataChanged () {
      const boolAlert =
          this.franchiseeID ||
          this.date ||
          this.selectedClassID ||
          this.selectedSectionID ||
          this.title ||
          this.classwork ||
          this.classworkfile.length > 0
      return boolAlert
    },
    getYear: async function () {
      try {
        this.isLoading = true
        const { data } = await http.get(
          `${constants.API_URL}/api/franchiseeAcademicYears?isCurrentAcademicYear=false`
        )
        this.academicYears = data.rows
        const currentAcademicYear = Utils.getCurrentAcademicYear()
        let academicYear = this.academicYears.find((y) => {
          return y.academicYear.trim() === currentAcademicYear.trim()
        })
        this.academicYearID = academicYear ? academicYear.id : ''

        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      }
    },
    deleteclassworkfile (i) {
      this.classworkfile.splice(i, 1)
    },
    deletediscriptionfile (i) {
      this.discriptionfile.splice(i, 1)
    },
    getFranchiseeList: async function () {
      try {
        const response = await http.get(
          `${constants.API_URL}/api/franchisee/active`
        )
        let data = response.data
        this.franchiseeArr = data.rows
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        console.log('Error While fetching franchisee', errorMessage)
        this.lock = false
        this.hasClicked = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    getClassList: async function () {
      try {
        this.isLoading = true
        const fb = []
        let z = []
        this.classSectionArray = []
        let fbString = ''
        console.log(this.franchiseeID)
        if (
          typeof this.franchiseeID === 'object' &&
            this.franchiseeID !== null
        ) {
          this.franchiseeID.forEach((element) => {
            fb.push(element.id)
          })
        }
        if (fb.length > 0) {
          fbString = fb.toString()
        }

        let { data } = await http.get(
          `${constants.API_URL}/api/student/get-all-classby-franchisee?franchiseeID=${fbString}&academicYearID=${this.academicYearID}`
        )

        if (data) {
          _.map(data, (a) => {
            _.map(a.studentSections, (b) => {
              let franchiseeName = b.studentAdmissions[0].franchisee.companyName
              let franchiseeId = b.studentAdmissions[0].franchisee.id
              b.value = `${franchiseeName}-${a.name} - ${b.name}`
              b.id = { franchiseeID: franchiseeId, sectionID: b.id }
              z.push(b)
            })
          })
        }

        this.classSectionArray = z
        this.isLoading = false
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
        console.log('errorMessage', errorMessage)
      }
    },
    changeSections: async function () {
      this.selectedStudent = []
      this.studentArray = []
      try {
        this.isLoading = true
        let sectionarray = this.sections.find(
          (obj) => obj.id === this.selectedClassID
        )
        if (sectionarray) {
          this.classWiseSections = sectionarray.studentSections
        } else {
          this.classWiseSections = []
        }
      } catch (e) {
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        console.log('errorMessage', errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    save: async function () {
      if (this.classSectionID.length < 1) {
        this.errMsg('Kindly select atleast one class section!')
        return false
      }
      /** Remove Empty <p> tags classwork **/
      let classworkTest = this.classwork
      classworkTest = classworkTest.replace(/(<([^>]+)>)/gi, '')
      classworkTest = classworkTest.replace(/&nbsp;/g, '')
      classworkTest = classworkTest.trim()

      if (
        (this.classWorkTitle === '' || this.classWorkTitle === null)
      ) {
        return this.$dialog.message.warning(
          'Please Fill Title',
          {
            position: 'top',
            timeout: 4000
          }
        )
      }

      if (classworkTest === '' || classworkTest === null) {
        return this.$dialog.message.warning(
          'Please Fill Altleast One Of These Data(ClassWork (or) Discription)',
          {
            position: 'top',
            timeout: 4000
          }
        )
      }
      if (this.franchiseeID.length === 0) {
        return this.$dialog.message.error('Please select franchisee', {
          position: 'top',
          timeout: 4000
        })
      }
      let formData = new FormData()
      if (this.franchiseeID.length > 0) {
        this.sendFranchisee = this.franchiseeID.map((obj) => obj.id)
      }
      formData.append('academicYearID', this.academicYearID)
      formData.append('franchiseeID', JSON.stringify(this.sendFranchisee))
      formData.append('title', this.classWorkTitle)
      formData.append('classWork', this.classwork)
      formData.append('date', this.date)

      for (let i = 0; i < this.classworkfile.length; i++) {
        formData.append('classWorkfile', this.classworkfile[i])
      }
      formData.append('workType', 'classWork')
      let newArr = _.map(this.classSectionID, (a) => a.id)
      formData.append('sectionID', JSON.stringify(newArr))
      this.hasClicked = true
      try {
        this.isLoading = true
        await http.post(
          `${constants.API_URL}/api/v1/communication/studentSubjectDairy`,
          formData
        )
        this.loader = false
        this.isLoading = false
        this.$router.push({ name: 'viewClassWork' })
        return this.$dialog.info({
          title: 'Success',
          text: 'Saved successfully'
        })
      } catch (e) {
        this.isLoading = false
        const errorMessage =
            (e && e.response && e.response.data.message) || e.message
        console.log('Error While Details', errorMessage)
        this.lock = false
        this.hasClicked = false
        this.loader = false
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    onclassFilechange () {
      let r = this.classworkfile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.classworkfile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style scoped>
  textarea {
    background-color: #ffffff;
    border-color: #dbdbdb;
    border-radius: 4px;
    color: #363636;
    height: 9.5rem;
  }
  </style>
